import {
  CLEAR_CONTRACTS,
  CLEAR_CONTRACT_DETAIL,
  CLEAR_CONTRACT_OPTIONS,
  LOAD_CONTRACTS,
  LOAD_CONTRACT_AVAL_LIST,
  LOAD_CONTRACT_DETAIL,
  LOAD_CONTRACT_PAYMENT_SCHEDULE,
  LOAD_RENT_BALANCE_SCHEDULE,
  LOAD_CONTRACT_FISCAL_INTEREST_BALANCE,
  LOAD_CONTRACT_FISCAL_CAPITAL_BALANCE,
  SAVE_CONTRACT_OPTIONS,
  LOAD_UPFRONT_RENT_NEXT_PERIOD,
  LOAD_NEXT_RENT_PERIOD,
  LOAD_CONTRACT_EVENTS,
  LOAD_CONTRACT_ACCOUNTING_INTEREST_BALANCE,
  LOAD_CONTRACT_ACCOUNTING_CAPITAL_BALANCE
} from '../actions/contractActions';

const initialState = {
  options: {
    limit: +process.env.REACT_APP_TABLE_SIZE,
    page: 0,
    fullScheduleView: false
  },
  items: [],
  count: 0,
  detail: { equipmentLocation: {}, avals: [] },
  rentBalanceSchedule: [],
  fiscalInterestBalance: [],
  fiscalCapitalBalance: [],
  upfrontRent: null,
  nextRent: null,
  events: [],
  accountingCapitalBalance: [],
  accountingInterestBalance: []
};

const contracReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_CONTRACTS.success: {
      return {
        ...state,
        items: action.items,
        count: action.count
      };
    }
    case CLEAR_CONTRACTS: {
      return initialState;
    }
    case SAVE_CONTRACT_OPTIONS: {
      return {
        ...state,
        options: { ...state.options, ...action.options }
      };
    }
    case CLEAR_CONTRACT_OPTIONS: {
      return {
        ...state,
        options: initialState.options
      };
    }
    case LOAD_CONTRACT_DETAIL.success: {
      return {
        ...state,
        detail: {
          ...state.detail,
          ...action.data,
          contractCession: action.data.contractCession || null,
          cessionPromissoryNote: action.data.cessionPromissoryNote || null
        }
      };
    }
    case CLEAR_CONTRACT_DETAIL: {
      return {
        ...state,
        detail: initialState.detail
      };
    }
    case LOAD_CONTRACT_PAYMENT_SCHEDULE.success: {
      return {
        ...state,
        detail: {
          ...state.detail,
          paymentSchedule: action.data
        }
      };
    }
    case LOAD_RENT_BALANCE_SCHEDULE.success: {
      return {
        ...state,
        rentBalanceSchedule: action.payload
      };
    }
    case LOAD_CONTRACT_FISCAL_INTEREST_BALANCE.success: {
      return {
        ...state,
        fiscalInterestBalance: action.payload
      };
    }
    case LOAD_CONTRACT_FISCAL_CAPITAL_BALANCE.success: {
      return {
        ...state,
        fiscalCapitalBalance: action.payload
      };
    }
    case LOAD_CONTRACT_AVAL_LIST.success: {
      return {
        ...state,
        detail: {
          ...state.detail,
          avals: action.payload
        }
      };
    }
    case LOAD_UPFRONT_RENT_NEXT_PERIOD.success: {
      return {
        ...state,
        upfrontRent: action.data
      };
    }

    case LOAD_UPFRONT_RENT_NEXT_PERIOD.failure: {
      return {
        ...state,
        upfrontRent: null
      };
    }
    case LOAD_NEXT_RENT_PERIOD.success: {
      return {
        ...state,
        nextRent: action.data
      };
    }
    case LOAD_NEXT_RENT_PERIOD.failure: {
      return {
        ...state,
        nextRent: null
      };
    }
    case LOAD_CONTRACT_EVENTS.success: {
      return {
        ...state,
        events: action.payload
      };
    }
    case LOAD_CONTRACT_ACCOUNTING_INTEREST_BALANCE.success: {
      return {
        ...state,
        accountingInterestBalance: action.data
      };
    }
    case LOAD_CONTRACT_ACCOUNTING_CAPITAL_BALANCE.success: {
      return {
        ...state,
        accountingCapitalBalance: action.data
      };
    }
    default: {
      return state;
    }
  }
};

export default contracReducer;
